import { useState } from "react";
import classes from "./DeleteAccountRoute.module.css";
import {toast} from "react-toastify";
import axios from "axios";
import { otpSendApi } from "../api/api";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";

const DeleteAccountRoute = () => {
  const [email, setEmail] = useState("");
  const [deleteLoading,setDeleteLoading]=useState(false);
  const navigate=useNavigate();

  const submitHandler=async(e:any)=>{
    e.preventDefault();
    try {
      setDeleteLoading(true);
      const response=await axios.post(otpSendApi,{
        email:email
      })

      setDeleteLoading(false);

      console.log(response,'respone....');


      toast.success("Otp Sent Successfully!");
      navigate("/otp",{
        state:{
          token:response?.data?.token ?? response?.data?.result?.token,
          email:response?.data?.email ?? response?.data?.result?.email
        }
      })

    } catch (error:any) {
      setDeleteLoading(false);

      console.log(error,'error--');
      toast.error(error?.response?.data?.error);
    }
  }

  return (
    <div className={classes.auth_modal}>
      <div className={classes.auth_sub_modal}>
        <div className={classes.form_modal}>
          <p className={classes.title}>Delete Account</p>

          <form className={classes.form} onSubmit={submitHandler}>
            <input
              type="email"
              autoFocus
              placeholder="Enter Your Email"
              className={classes.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button
              type="submit"
                disabled={deleteLoading}
              className={classes.signup_btn}
            >
              {deleteLoading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner />
                </div>
              ) : (
                "Delete Account"
              )}
            </button>
          </form>
        </div>
        <div className={classes.benefits_modal}>
          <p className={classes.benefits_title}>
            Are You Sure You Want to Delete Your Account?
          </p>

          <div className={classes.benefits}>
            <div className={classes.benefit}>
              <div className={classes.benefit_title}>
                <i className={`pi pi-circle-fill ${classes.icon}`} />
                <p className={classes.bt}>
                  We're sorry to see you go. Deleting your account will result
                  in the following:
                </p>
              </div>
              <p className={classes.bd}>
                Permanent loss of your data and friends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountRoute;
